module.exports = __webpack_public_path__ + "static/media/partner-logo14.d952864d.png";